import {
	type AgentChatSession,
	clearAgentChatSession,
	getAgentChatSession,
	resetAgentChatSessionsForTests,
	setAgentChatSession,
} from "./agent-chat-session-store";
import {
	clearAgentSessionTouchedShapes,
	getAgentSessionTouchedShapes,
	resetAgentSessionTouchedShapesForTests,
} from "./agent-session-shape-tracker";

export type AgentSession = AgentChatSession & {
	touchedShapeIds: string[];
};

export function getAgentSession(): AgentSession {
	const chat = getAgentChatSession();

	return {
		...chat,
		touchedShapeIds: getAgentSessionTouchedShapes(),
	};
}

export function setAgentSession(partial: Partial<AgentChatSession>) {
	setAgentChatSession(partial);
}

export function clearAgentSession() {
	clearAgentChatSession();
	clearAgentSessionTouchedShapes();
}

export function getAgentSessionTouchedShapeIds() {
	return getAgentSessionTouchedShapes();
}

export function resetAgentSessionsForTests() {
	resetAgentChatSessionsForTests();
	resetAgentSessionTouchedShapesForTests();
}
